import { render } from "./downgrade-losing-features-list.vue?vue&type=template&id=3cd60180&lang=pug"
import script from "./downgrade-losing-features-list.vue?vue&type=script&lang=js"
export * from "./downgrade-losing-features-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__